import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonUtils} from "../../utils/common";
import {SettlementItem} from "../../models/settlement-item.model";

@Component({
  selector: 'app-settlement-item-details',
  templateUrl: './settlement-item-details.component.html',
  styleUrls: ['./settlement-item-details.component.scss'],
})
export class SettlementItemDetailsComponent implements OnInit {


  @Input() settlementItems: SettlementItem[];
  @Output() actionCanceledEmitter = new EventEmitter<SettlementItem[]>();


  constructor(public commonUtils : CommonUtils) {

  }

  ngOnInit() {
    console.log(this.settlementItems);
  }

  onCancel() {
    this.actionCanceledEmitter.emit(this.settlementItems);
  }

  settlementItemType(settlementItem: any): string {
    if (settlementItem.p24Fee) {
      return "Rozliczenie Vetineo"
    }
    if (settlementItem.vistPrice) {
      return "Rozliczenie wizyty"
    }
    return 'Rozliczenie'
  }
}

